import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../../locales/en.json";
import fr from "../../locales/fr.json";
import {
  FRENCH_TYPOGRAPHY_POST_PROCESSOR,
  frenchTypographyPostProcessor,
} from "./frenchTypography";

export const getBrowserLanguage = () => {
  const browserLanguage = navigator.language;
  return browserLanguage.startsWith("fr") ? "fr" : "en";
};

i18n.on("languageChanged", (language) => {
  document.documentElement.lang = language;
});

void i18n
  .use(initReactI18next)
  .use(frenchTypographyPostProcessor)
  .init({
    resources: {
      en,
      fr,
    },
    lng: getBrowserLanguage(),
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    postProcess: [FRENCH_TYPOGRAPHY_POST_PROCESSOR],
  });

export default i18n;
